export const durationDates = (duration: string) => {
	const intervalTmp = duration.split('","');
	// console.log('intervalStringArray', intervalStringArrayTmp);
	return intervalTmp.map((item) => {
		let newItem = item.replace('[', '');
		newItem = newItem.replace(']', '');
		newItem = newItem.replace('(', '');
		newItem = newItem.replace(')', '');
		newItem = newItem.replace('"', '');
		newItem = newItem.replace(',', '');

		return newItem;
	});
};
